import { Types } from '@store/types';

export const setDesignViewModalInfo = (postData) => async (dispatch) => {
	await dispatch({
		type: Types.SET_DESIGN_VIEW_MODAL_INFO,
		payload: postData
	});
};

export const updateDesignViewModalInfo = (postData) => async (dispatch) => {
	await dispatch({
		type: Types.UPDATE_DESIGN_VIEW_MODAL_INFO,
		payload: postData
	});
};

export const clearDesignViewModalInfo = () => async (dispatch) => {
	await dispatch({
		type: Types.CLEAR_DESIGN_VIEW_MODAL_INFO,
		payload: {}
	});
};
